import { render, staticRenderFns } from "./FileVersions.vue?vue&type=template&id=0381d9ba&"
import script from "./FileVersions.vue?vue&type=script&lang=js&"
export * from "./FileVersions.vue?vue&type=script&lang=js&"
import style0 from "./FileVersions.vue?vue&type=style&index=0&id=0381d9ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports